export const filterValuesSeparatorSplitRegex = new RegExp(
  /\[\.\](?=[A-z0-9])/,
  'u'
);
